<app-breadcrumb [pathList]="pathList"></app-breadcrumb>
<div [ngBusy]="{busy: busy, message: 'Loading...', backdrop: false, delay: 0, minDuration: 600}"></div>
<div class="container-fluid">
    <app-single (pathListEvent)="loga($event)" [id]="id" [single]="single" [componentService]="userService"
    [routePart]="'user'"></app-single>
    <app-alertbox #alertbox1 [alerts]=""></app-alertbox>
</div>